import script from "./orderIndexPage.vue?vue&type=script&setup=true&lang=js"
export * from "./orderIndexPage.vue?vue&type=script&setup=true&lang=js"

import "./orderIndexPage.vue?vue&type=style&index=0&id=920d585e&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-920d585e"]])

export default __exports__